import React, { useState, useEffect } from 'react';
import axios from "axios";
import { localAxiosGet, localAxios } from "../../../Axios/axios";
import TokenExpirePopup from "../../../components/TokenExpirePopup";

import {
  Box,
  Typography,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  TableContainer,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Avatar,
  Rating,
  Chip,
  Button,
  Paper,
  IconButton,
  Tooltip,
  Modal,
  Grid,
  Card,
  CardContent,
  Checkbox,
  Snackbar,
  Alert,
  CircularProgress
} from '@mui/material';

import {
  Search,
  Refresh,
  CheckCircle,
  AccessTime,
  Group,
  ReportProblem,
  Info,
  Edit,
  Warning,
  Timeline,
  ThumbUp,
  Settings,
  FilterList,
  Flag,
  Send,
  Save,
  Email
} from '@mui/icons-material';
import HREmployeeReviewDetails from '../../HR/Performance_HR/HREmployeeReviewDetails'
import AssignmentTurnedIn from '@mui/icons-material/AssignmentTurnedIn';

const HREmployeeReviewList = ({ employees = [], onSelectEmployee }) => {
  const [searchQuery, setSearchQuery] = useState('');
  const [filterStatus, setFilterStatus] = useState('All');
  const [filterDepartment, setFilterDepartment] = useState('All');
  const [filterManager, setFilterManager] = useState('All');
  const [openDialog, setOpenDialog] = useState(false);
  const [selectedEmployee, setSelectedEmployee] = useState(null);
  const [selectedCardFilter, setSelectedCardFilter] = useState('');
  const [stats, setStats] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [appraisalPeriod, setAppraisalPeriod] = useState('');
  const [showAppraisalDropdown, setShowAppraisalDropdown] = useState(false);
  const [selectedEmployees, setSelectedEmployees] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success' });
  const [currentPeriod, setCurrentPeriod] = useState('');
  const [isSavingPeriod, setIsSavingPeriod] = useState(false);
  const [isSharing, setIsSharing] = useState(false);
  const [currentYear, setCurrentYear] = useState('');

  // Dummy employee data - Updated to include managerReviewFlag
  const dummyEmployees = [
    {
      id: 1,
      name: 'John Smith',
      position: 'Software Engineer',
      department: 'Engineering',
      managerName: 'Sarah Wilson',
      managerReviewDate: '2024-01-15',
      overallRating: 4.2,
      status: 'pending_review',
      hrStatus: 'pending_hr_review',
      avatar: '',
      nextReviewDate: '2024-02-15',
      appraisalYear: '2024',
      managerReviewFlag: true,
      email: 'john.smith@example.com'
    },
    {
      id: 2,
      name: 'Emily Johnson',
      position: 'Product Manager',
      department: 'Product',
      managerName: 'Michael Brown',
      managerReviewDate: '2024-01-10',
      overallRating: 4.5,
      status: 'completed',
      hrStatus: 'hr_reviewed',
      avatar: '',
      nextReviewDate: '2024-02-10',
      appraisalYear: '2024',
      managerReviewFlag: true,
      email: 'emily.johnson@example.com'
    },
    {
      id: 3,
      name: 'David Chen',
      position: 'UX Designer',
      department: 'Design',
      managerName: 'Lisa Taylor',
      managerReviewDate: '',
      overallRating: 3.8,
      status: 'in_progress',
      hrStatus: 'awaiting_manager',
      avatar: '',
      nextReviewDate: '2024-02-12',
      appraisalYear: '2024',
      managerReviewFlag: false,
      email: 'david.chen@example.com'
    },
    {
      id: 4,
      name: 'Maria Garcia',
      position: 'Data Analyst',
      department: 'Analytics',
      managerName: 'Robert Davis',
      managerReviewDate: '2024-01-08',
      overallRating: 4.8,
      status: 'acknowledged',
      hrStatus: 'finalized',
      avatar: '',
      nextReviewDate: '2024-02-08',
      appraisalYear: '2024',
      managerReviewFlag: true,
      email: 'maria.garcia@example.com'
    },
    {
      id: 5,
      name: 'James Wilson',
      position: 'DevOps Engineer',
      department: 'Engineering',
      managerName: 'Sarah Wilson',
      managerReviewDate: '',
      overallRating: 4.1,
      status: 'pending_review',
      hrStatus: 'pending_hr_review',
      avatar: '',
      nextReviewDate: '2024-02-14',
      appraisalYear: '2024',
      managerReviewFlag: false,
      email: 'james.wilson@example.com'
    },
    {
      id: 6,
      name: 'Sophia Martinez',
      position: 'Marketing Specialist',
      department: 'Marketing',
      managerName: 'Thomas Lee',
      managerReviewDate: '2024-01-09',
      overallRating: 3.9,
      status: 'completed',
      hrStatus: 'hr_reviewed',
      avatar: '',
      nextReviewDate: '2024-02-09',
      appraisalYear: '2024',
      managerReviewFlag: true,
      email: 'sophia.martinez@example.com'
    },
    {
      id: 7,
      name: 'Daniel Kim',
      position: 'QA Engineer',
      department: 'Quality Assurance',
      managerName: 'Jennifer White',
      managerReviewDate: '',
      overallRating: 4.3,
      status: 'in_progress',
      hrStatus: 'awaiting_manager',
      avatar: '',
      nextReviewDate: '2024-02-11',
      appraisalYear: '2024',
      managerReviewFlag: false,
      email: 'daniel.kim@example.com'
    },
    {
      id: 8,
      name: 'Amanda Clark',
      position: 'HR Business Partner',
      department: 'Human Resources',
      managerName: 'Kevin Adams',
      managerReviewDate: '2024-01-07',
      overallRating: 4.6,
      status: 'acknowledged',
      hrStatus: 'finalized',
      avatar: '',
      nextReviewDate: '2024-02-07',
      appraisalYear: '2024',
      managerReviewFlag: true,
      email: 'amanda.clark@example.com'
    },
    {
      id: 9,
      name: 'Christopher Lee',
      position: 'Backend Developer',
      department: 'Engineering',
      managerName: 'Sarah Wilson',
      managerReviewDate: '2024-01-13',
      overallRating: 4.0,
      status: 'pending_review',
      hrStatus: 'pending_hr_review',
      avatar: '',
      nextReviewDate: '2024-02-13',
      appraisalYear: '2024',
      managerReviewFlag: true,
      email: 'christopher.lee@example.com'
    },
    {
      id: 10,
      name: 'Olivia Brown',
      position: 'Frontend Developer',
      department: 'Engineering',
      managerName: 'Sarah Wilson',
      managerReviewDate: '',
      overallRating: 4.4,
      status: 'completed',
      hrStatus: 'hr_reviewed',
      avatar: '',
      nextReviewDate: '2024-02-16',
      appraisalYear: '2024',
      managerReviewFlag: false,
      email: 'olivia.brown@example.com'
    }
  ];

  // Safe default for employees prop - use dummy data if empty
  const safeEmployees = Array.isArray(employees) && employees.length > 0 ? employees : dummyEmployees;

  // Initialize current year
  useEffect(() => {
    const year = new Date().getFullYear().toString();
    setCurrentYear(year);

    // Load saved appraisal period from localStorage or API
    const savedPeriod = localStorage.getItem('appraisalPeriod');
    if (savedPeriod) {
      setAppraisalPeriod(savedPeriod);
      calculateCurrentPeriod(savedPeriod);
    }
  }, []);

  // Calculate current period based on selected period type and current date
 const calculateCurrentPeriod = (periodType) => {
  const now = new Date();
  const month = now.getMonth() + 1; // 1-12
  const year = now.getFullYear();
  
  let period = '';
  
  switch(periodType) {
    case 'quarterly':
      if (month >= 1 && month <= 3) period = `Q1 ${year}`;
      else if (month >= 4 && month <= 6) period = `Q2 ${year}`;
      else if (month >= 7 && month <= 9) period = `Q3 ${year}`;
      else period = `Q4 ${year}`;
      break;
      
    case 'halfyearly':
      if (month >= 1 && month <= 6) period = `H1 ${year}`;
      else period = `H2 ${year}`;
      break;
      
    case 'yearly':
      period = `Yearly ${year}`;
      break;
      
    default:
      period = '';
  }
  
  setCurrentPeriod(period);
  return period;
};

  const handleSearchChange = (event) => {
    setSearchQuery(event.target.value);
  };

  const handleStatusFilterChange = (event) => {
    setFilterStatus(event.target.value);
  };

  const handleDepartmentFilterChange = (event) => {
    setFilterDepartment(event.target.value);
  };

  const handleManagerFilterChange = (event) => {
    setFilterManager(event.target.value);
  };

  const handleSelectedEmployeeReviewDetails = (employee) => {
    setSelectedEmployee(employee);
    setOpenDialog(true);
  };

  const handleAppraisalPeriodChange = (event) => {
    setAppraisalPeriod(event.target.value);
  };

  const handleSaveAppraisalPeriod = () => {
    if (!appraisalPeriod) {
      setSnackbar({
        open: true,
        message: 'Please select an appraisal period',
        severity: 'warning'
      });
      return;
    }

    setIsSavingPeriod(true);

    // Simulate API call delay
    setTimeout(() => {
      // Calculate current period based on selected type
      const now = new Date();
      const month = now.getMonth() + 1; // 1-12
      const year = now.getFullYear();

      let period = '';

      switch (appraisalPeriod) {
        case 'quarterly':
          if (month >= 1 && month <= 3) period = `Q1 ${year}`;
          else if (month >= 4 && month <= 6) period = `Q2 ${year}`;
          else if (month >= 7 && month <= 9) period = `Q3 ${year}`;
          else period = `Q4 ${year}`;
          break;

        case 'halfyearly':
          if (month >= 1 && month <= 6) period = `H1 ${year}`;
          else period = `H2 ${year}`;
          break;

        case 'yearly':
          period = `Yearly ${year}`;
          break;

        default:
          period = '';
      }

      setCurrentPeriod(period);

      // Save to localStorage for persistence
      localStorage.setItem('appraisalPeriod', appraisalPeriod);
      localStorage.setItem('currentAppraisalPeriod', period);

      setShowAppraisalDropdown(false);
      setSnackbar({
        open: true,
        message: `Appraisal period set to: ${period}`,
        severity: 'success'
      });

      setIsSavingPeriod(false);
    }, 500); // Simulate 500ms delay
  };
  // Extract unique managers from employees
  const managers = [...new Set(safeEmployees.map(emp => emp.managerName).filter(Boolean))];

  // Extract unique departments
  const departments = [...new Set(safeEmployees.map(emp => emp.department).filter(Boolean))];

  const hr_id = localStorage.getItem('userId');
  const accessToken = localStorage.getItem('accessToken');

  useEffect(() => {
    const fetchStats = async () => {
      setIsLoading(true);
      try {
        const response = await axios(
          localAxiosGet(`/performanceHr/getAppraisalDashboardStats?hr_id=53`, accessToken)
        );
        if (response.data?.statusCode === 200) {
          setStats(response.data.result);
        } else {
          // Set default stats based on dummy data
          const allEmployees = safeEmployees.length;
          const managerReviewed = safeEmployees.filter(emp => emp.managerReviewFlag).length;
          const pendingManagerReview = safeEmployees.filter(emp => !emp.managerReviewFlag).length;
          const completed = safeEmployees.filter(emp => emp.status === 'completed').length;
          const acknowledged = safeEmployees.filter(emp => emp.status === 'acknowledged').length;
          const overdue = safeEmployees.filter(emp =>
            emp.nextReviewDate && new Date(emp.nextReviewDate) < new Date() &&
            emp.status !== 'completed' && emp.status !== 'acknowledged'
          ).length;

          setStats({
            all_employees: allEmployees,
            pending_review: pendingManagerReview,
            completed: completed,
            acknowledged: acknowledged,
            overdue: overdue,
            manager_reviewed: managerReviewed
          });
        }
      } catch (error) {
        console.error('Error fetching appraisal dashboard stats:', error);
        // Set default stats based on dummy data on error
        const allEmployees = safeEmployees.length;
        const managerReviewed = safeEmployees.filter(emp => emp.managerReviewFlag).length;
        const pendingManagerReview = safeEmployees.filter(emp => !emp.managerReviewFlag).length;
        const completed = safeEmployees.filter(emp => emp.status === 'completed').length;
        const acknowledged = safeEmployees.filter(emp => emp.status === 'acknowledged').length;
        const overdue = safeEmployees.filter(emp =>
          emp.nextReviewDate && new Date(emp.nextReviewDate) < new Date() &&
          emp.status !== 'completed' && emp.status !== 'acknowledged'
        ).length;

        setStats({
          all_employees: allEmployees,
          pending_review: pendingManagerReview,
          completed: completed,
          acknowledged: acknowledged,
          overdue: overdue,
          manager_reviewed: managerReviewed
        });
      } finally {
        setIsLoading(false);
      }
    };
    fetchStats();
  }, [accessToken, hr_id]);

  const compactCardCategories = [
    {
      key: 'all_employees',
      title: 'All Employees',
      icon: Group,
      color: '#1976D2',
      countKey: 'all_employees',
    },
    {
      key: 'manager_reviewed',
      title: 'Manager Reviewed',
      icon: CheckCircle,
      color: '#388E3C',
      countKey: 'manager_reviewed',
    },
    {
      key: 'pending_review',
      title: 'Pending Manager Review',
      icon: AccessTime,
      color: '#FBC02D',
      countKey: 'pending_review',
    },
    {
      key: 'completed',
      title: 'Completed',
      icon: AssignmentTurnedIn,
      color: '#7B1FA2',
      countKey: 'completed',
    },
    {
      key: 'overdue',
      title: 'Overdue',
      icon: ReportProblem,
      color: '#D32F2F',
      countKey: 'overdue',
    },
  ];

  const getManagerReviewFlag = (employee) => {
    return employee.managerReviewFlag ? (
      <Tooltip title="Manager has reviewed">
        <Flag sx={{ color: '#4CAF50' }} />
      </Tooltip>
    ) : (
      <Tooltip title="Awaiting manager review">
        <Flag sx={{ color: '#BDBDBD' }} />
      </Tooltip>
    );
  };

  const getHRStatusChip = (status) => {
    switch (status) {
      case 'pending_review':
        return <Chip label="Pending Review" color="warning" size="small" icon={<AccessTime fontSize="small" />} />;
      case 'in_progress':
        return <Chip label="In Progress" color="info" size="small" icon={<Timeline fontSize="small" />} />;
      case 'completed':
        return <Chip label="Completed" color="success" size="small" icon={<CheckCircle fontSize="small" />} />;
      case 'acknowledged':
        return <Chip label="Acknowledged" color="primary" size="small" icon={<ThumbUp fontSize="small" />} />;
      default:
        return <Chip label="Unknown" color="default" size="small" />;
    }
  };

  const filteredEmployees = safeEmployees.filter(employee => {
    const matchesSearch = employee.name?.toLowerCase().includes(searchQuery.toLowerCase()) ||
      employee.position?.toLowerCase().includes(searchQuery.toLowerCase()) ||
      employee.department?.toLowerCase().includes(searchQuery.toLowerCase());

    const matchesStatus = filterStatus === 'All' || employee.hrStatus === filterStatus;
    const matchesDepartment = filterDepartment === 'All' || employee.department === filterDepartment;
    const matchesManager = filterManager === 'All' || employee.managerName === filterManager;

    const matchesCardFilter = !selectedCardFilter || selectedCardFilter === 'all_employees' ||
      (selectedCardFilter === 'manager_reviewed' && employee.managerReviewFlag) ||
      (selectedCardFilter === 'pending_review' && !employee.managerReviewFlag) ||
      (selectedCardFilter === 'completed' && employee.status === 'completed') ||
      (selectedCardFilter === 'acknowledged' && employee.status === 'acknowledged') ||
      (selectedCardFilter === 'overdue' &&
        employee.nextReviewDate &&
        new Date(employee.nextReviewDate) < new Date() &&
        employee.status !== 'completed' &&
        employee.status !== 'acknowledged'
      );

    return matchesSearch && matchesStatus && matchesDepartment && matchesManager && matchesCardFilter;
  });

  const handleResetFilters = () => {
    setFilterStatus('All');
    setFilterDepartment('All');
    setFilterManager('All');
    setSearchQuery('');
    setSelectedCardFilter('');
    setSelectedEmployees([]);
    setSelectAll(false);
  };

  // Selection handlers
  const handleSelectAll = () => {
    if (selectAll) {
      setSelectedEmployees([]);
    } else {
      setSelectedEmployees(filteredEmployees.map(emp => emp.id));
    }
    setSelectAll(!selectAll);
  };

  const handleSelectEmployee = (employeeId) => {
    if (selectedEmployees.includes(employeeId)) {
      setSelectedEmployees(selectedEmployees.filter(id => id !== employeeId));
    } else {
      setSelectedEmployees([...selectedEmployees, employeeId]);
    }
  };

  // Share appraisal reports with selected employees
  const handleShareAppraisalReports = async () => {
    if (selectedEmployees.length === 0) {
      setSnackbar({
        open: true,
        message: 'Please select at least one employee to share appraisal reports',
        severity: 'warning'
      });
      return;
    }

    if (!currentPeriod) {
      setSnackbar({
        open: true,
        message: 'Please set appraisal period first',
        severity: 'warning'
      });
      return;
    }

    setIsSharing(true);
    try {
      const hrId = localStorage.getItem('userId');
      const accessToken = localStorage.getItem('accessToken');

      // Get selected employee details
      const selectedEmployeeDetails = safeEmployees.filter(emp =>
        selectedEmployees.includes(emp.id)
      );

      // Call API to share appraisal reports
      const response = await localAxios(
        `/performanceHr/shareAppraisalReports`,
        {
          hr_id: hrId,
          employee_ids: selectedEmployees,
          appraisal_period: appraisalPeriod,
          current_period: currentPeriod,
          employees: selectedEmployeeDetails.map(emp => ({
            id: emp.id,
            name: emp.name,
            email: emp.email,
            department: emp.department
          }))
        },
        accessToken
      );

      if (response.data?.statusCode === 200) {
        setSnackbar({
          open: true,
          message: `Appraisal reports shared with ${selectedEmployees.length} employee(s) for ${currentPeriod}`,
          severity: 'success'
        });
        // Clear selection after sharing
        setSelectedEmployees([]);
        setSelectAll(false);
      } else {
        throw new Error(response.data?.message || 'Failed to share appraisal reports');
      }
    } catch (error) {
      console.error('Error sharing appraisal reports:', error);
      setSnackbar({
        open: true,
        message: 'Failed to share appraisal reports. Please try again.',
        severity: 'error'
      });
    } finally {
      setIsSharing(false);
    }
  };

  const handleCloseSnackbar = () => {
    setSnackbar({ ...snackbar, open: false });
  };

  if (isLoading) {
    return (
      <Paper sx={{ p: 3, borderRadius: 2, boxShadow: 3, mb: 3 }}>
        <Typography variant="h6" align="center">
          Loading dashboard...
        </Typography>
      </Paper>
    );
  }

  return (
    <Paper sx={{ p: 3, borderRadius: 2, boxShadow: 3, mb: 3 }}>
      {/* Current Appraisal Period Display */}
     {currentPeriod && (
  <Box sx={{ 
    mb: 2,
    display: 'flex',
    alignItems: 'center',
    gap: 1,
    flexWrap: 'wrap'
  }}>
    <Typography variant="body2" fontWeight="medium" color="text.secondary">
      Active Period:
    </Typography>
    <Box sx={{ 
      display: 'inline-flex',
      alignItems: 'center',
      gap: 0.5,
      px: 1.5,
      py: 0.5,
      backgroundColor: 'primary.main',
      color: 'white',
      borderRadius: 1,
      fontWeight: 'bold',
      fontSize: '0.875rem'
    }}>
      <span>{currentPeriod}</span>
      <Typography variant="caption" sx={{ ml: 0.5, opacity: 0.9 }}>
        ({appraisalPeriod.charAt(0).toUpperCase() + appraisalPeriod.slice(1)})
      </Typography>
    </Box>
    {selectedEmployees.length > 0 && (
      <Chip 
        label={`${selectedEmployees.length} selected`}
        size="small"
        color="secondary"
        sx={{ ml: 1 }}
      />
    )}
  </Box>
)}
      <Box sx={{ display: 'flex', flexDirection: 'column', mb: 3 }}>
        <Typography variant="h6" fontWeight="bold">
          Appraisal Overview
        </Typography>

        {/* Appraisal Period Configuration Section */}
        <Box sx={{ my: 2, display: 'flex', alignItems: 'center', gap: 2, flexWrap: 'wrap' }}>
          <Button
            variant="outlined"
            startIcon={<Settings />}
            onClick={() => setShowAppraisalDropdown(!showAppraisalDropdown)}
            sx={{
              px: 3,
              fontWeight: 'bold',
              textTransform: 'none'
            }}
          >
            {appraisalPeriod ? 'Change Appraisal Period' : 'Define Appraisal Period'}
          </Button>

          {showAppraisalDropdown && (
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, flexWrap: 'wrap' }}>
              <FormControl variant="outlined" size="small" sx={{ minWidth: 150 }}>
                <InputLabel id="appraisal-period-label">Appraisal Period</InputLabel>
                <Select
                  labelId="appraisal-period-label"
                  id="appraisal-period"
                  value={appraisalPeriod}
                  onChange={handleAppraisalPeriodChange}
                  label="Appraisal Period"
                >
                  <MenuItem value="">
                    <em>Select Period</em>
                  </MenuItem>
                  <MenuItem value="quarterly">Quarterly</MenuItem>
                  <MenuItem value="halfyearly">Half Yearly</MenuItem>
                  <MenuItem value="yearly">Yearly</MenuItem>
                </Select>
              </FormControl>

              <Button
                variant="contained"
                startIcon={isSavingPeriod ? <CircularProgress size={20} color="inherit" /> : <Save />}
                onClick={handleSaveAppraisalPeriod}
                disabled={!appraisalPeriod || isSavingPeriod}
                sx={{
                  textTransform: 'none',
                  fontWeight: 'bold'
                }}
              >
                {isSavingPeriod ? 'Saving...' : 'Save Period'}
              </Button>

              <Button
                variant="text"
                onClick={() => {
                  setShowAppraisalDropdown(false);
                }}
                sx={{ textTransform: 'none' }}
              >
                Cancel
              </Button>
            </Box>
          )}

          {currentPeriod && !showAppraisalDropdown && (
            <Chip
              label={`Current Period: ${currentPeriod}`}
              color="primary"
              variant="filled"
              onDelete={() => {
                setAppraisalPeriod('');
                setCurrentPeriod('');
                localStorage.removeItem('appraisalPeriod');
                localStorage.removeItem('currentAppraisalPeriod');
                setSnackbar({
                  open: true,
                  message: 'Appraisal period reset',
                  severity: 'info'
                });
              }}
            />
          )}
        </Box>

        {/* Share Reports Button - Only show when period is set */}
        {currentPeriod && selectedEmployees.length > 0 && (
          <Box sx={{ mb: 2 }}>
            <Button
              variant="contained"
              startIcon={isSharing ? <CircularProgress size={20} color="inherit" /> : <Send />}
              onClick={handleShareAppraisalReports}
              disabled={isSharing || selectedEmployees.length === 0}
              sx={{
                backgroundColor: '#4CAF50',
                '&:hover': { backgroundColor: '#388E3C' },
                textTransform: 'none',
                fontWeight: 'bold'
              }}
            >
              {isSharing ? 'Sharing...' : `Share Appraisal Reports with ${selectedEmployees.length} Selected Employee(s)`}
            </Button>
          </Box>
        )}

        {/* Badge Style Summary */}
        <Box sx={{ my: 2 }}>
          <Typography variant="subtitle1" fontWeight="bold" sx={{ mb: 2 }}>
            Appraisal Summary:
          </Typography>
          <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
            {compactCardCategories.map((card) => {
              const IconComponent = card.icon;
              const count = stats?.[card.countKey] || 0;
              const isSelected = selectedCardFilter === card.key;

              return (
                <Box
                  key={card.key}
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 1,
                    px: 2,
                    py: 1,
                    borderRadius: 20,
                    cursor: 'pointer',
                    border: `1px solid ${card.color}`,
                    backgroundColor: isSelected ? card.color : 'transparent',
                    color: isSelected ? 'white' : card.color,
                    transition: 'all 0.2s',
                    '&:hover': {
                      backgroundColor: isSelected ? card.color : `${card.color}20`,
                    }
                  }}
                  onClick={() => setSelectedCardFilter(card.key)}
                >
                  <IconComponent sx={{ fontSize: 16 }} />
                  <Typography variant="body2" fontWeight="medium">
                    {card.title}: {count}
                  </Typography>
                </Box>
              );
            })}
          </Box>
        </Box>

        {/* Enhanced Filters Section */}
        <Box sx={{ mt: 2 }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2 }}>
            <FilterList color="action" />
            <Typography variant="subtitle1" fontWeight="bold">
              Filters
            </Typography>
          </Box>

          <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap' }}>
            <TextField
              placeholder="Search employees..."
              variant="outlined"
              size="small"
              value={searchQuery}
              onChange={handleSearchChange}
              InputProps={{
                startAdornment: (
                  <Search sx={{ color: 'action.active', mr: 1 }} />
                ),
              }}
              sx={{ width: 250 }}
            />

            <FormControl variant="outlined" size="small" sx={{ minWidth: 150 }}>
              <InputLabel id="status-filter-label">HR Status</InputLabel>
              <Select
                labelId="status-filter-label"
                id="status-filter"
                value={filterStatus}
                onChange={handleStatusFilterChange}
                label="HR Status"
              >
                <MenuItem value="All">All Statuses</MenuItem>
                <MenuItem value="awaiting_manager">Awaiting Manager</MenuItem>
                <MenuItem value="pending_hr_review">Pending HR Review</MenuItem>
                <MenuItem value="hr_reviewed">HR Reviewed</MenuItem>
                <MenuItem value="finalized">Finalized</MenuItem>
              </Select>
            </FormControl>

            <FormControl variant="outlined" size="small" sx={{ minWidth: 150 }}>
              <InputLabel id="department-filter-label">Department</InputLabel>
              <Select
                labelId="department-filter-label"
                id="department-filter"
                value={filterDepartment}
                onChange={handleDepartmentFilterChange}
                label="Department"
              >
                <MenuItem value="All">All Departments</MenuItem>
                {departments.map(dept => (
                  <MenuItem key={dept} value={dept}>{dept}</MenuItem>
                ))}
              </Select>
            </FormControl>

            <FormControl variant="outlined" size="small" sx={{ minWidth: 150 }}>
              <InputLabel id="manager-filter-label">Manager</InputLabel>
              <Select
                labelId="manager-filter-label"
                id="manager-filter"
                value={filterManager}
                onChange={handleManagerFilterChange}
                label="Manager"
              >
                <MenuItem value="All">All Managers</MenuItem>
                {managers.map(manager => (
                  <MenuItem key={manager} value={manager}>{manager}</MenuItem>
                ))}
              </Select>
            </FormControl>

            <Button
              variant="outlined"
              startIcon={<Refresh />}
              onClick={handleResetFilters}
              size="small"
              sx={{ textTransform: 'none' }}
            >
              Reset Filters
            </Button>

            {currentPeriod && (
              <Typography variant="body2" color="text.secondary" sx={{ ml: 1, alignSelf: 'center' }}>
                Filtering for: <strong>{currentPeriod}</strong>
              </Typography>
            )}
          </Box>
        </Box>
      </Box>

      {/* Employees Table with Selection */}
      <TableContainer>
        <Table>
          <TableHead sx={{ backgroundColor: '#f5f5f5' }}>
            <TableRow>
              <TableCell sx={{ fontWeight: 'bold', width: 50 }}>
                <Checkbox
                  checked={selectAll}
                  onChange={handleSelectAll}
                  indeterminate={selectedEmployees.length > 0 && selectedEmployees.length < filteredEmployees.length}
                />
              </TableCell>
              <TableCell sx={{ fontWeight: 'bold' }}>Employee</TableCell>
              <TableCell sx={{ fontWeight: 'bold' }}>Position</TableCell>
              <TableCell sx={{ fontWeight: 'bold' }}>Department</TableCell>
              <TableCell sx={{ fontWeight: 'bold' }}>Manager</TableCell>
              <TableCell sx={{ fontWeight: 'bold' }}>Manager Review Date</TableCell>
              <TableCell sx={{ fontWeight: 'bold' }}>Manager Review</TableCell>
              {/* <TableCell sx={{ fontWeight: 'bold' }}>Next Review Date</TableCell> */}
              {/* <TableCell sx={{ fontWeight: 'bold' }}>Actions</TableCell> */}
            </TableRow>
          </TableHead>
          <TableBody>
            {filteredEmployees.length > 0 ? (
              filteredEmployees.map((employee) => (
                <TableRow
                  key={employee.id}
                  sx={{
                    cursor: 'pointer',
                    '&:hover': { backgroundColor: 'rgba(0, 0, 0, 0.04)' },
                  }}
                >
                  <TableCell onClick={(e) => e.stopPropagation()}>
                    <Checkbox
                      checked={selectedEmployees.includes(employee.id)}
                      onChange={() => handleSelectEmployee(employee.id)}
                      onClick={(e) => e.stopPropagation()}
                    />
                  </TableCell>
                  <TableCell onClick={() => handleSelectedEmployeeReviewDetails(employee)}>
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                      <Avatar
                        alt={employee.name}
                        src={employee.avatar}
                        sx={{ mr: 2, bgcolor: 'primary.main' }}
                      >
                        {employee.name?.charAt(0) || 'U'}
                      </Avatar>
                      <Box>
                        <Typography variant="body1" fontWeight="medium">
                          {employee.name || 'Unknown Employee'}
                        </Typography>
                        <Typography variant="caption" color="text.secondary">
                          {employee.email || 'No email'}
                        </Typography>
                      </Box>
                    </Box>
                  </TableCell>
                  <TableCell onClick={() => handleSelectedEmployeeReviewDetails(employee)}>
                    {employee.position || 'N/A'}
                  </TableCell>
                  <TableCell onClick={() => handleSelectedEmployeeReviewDetails(employee)}>
                    {employee.department || 'N/A'}
                  </TableCell>
                  <TableCell onClick={() => handleSelectedEmployeeReviewDetails(employee)}>
                    {employee.managerName || 'N/A'}
                  </TableCell>
                  <TableCell onClick={() => handleSelectedEmployeeReviewDetails(employee)}>
                    {employee.managerReviewDate ? (
                      <Typography variant="body2">
                        {employee.managerReviewDate}
                      </Typography>
                    ) : (
                      <Typography variant="body2" color="text.secondary">
                        Not reviewed
                      </Typography>
                    )}
                  </TableCell>
                  <TableCell onClick={() => handleSelectedEmployeeReviewDetails(employee)}>
                    {getManagerReviewFlag(employee)}
                  </TableCell>
                  {/* <TableCell onClick={() => handleSelectedEmployeeReviewDetails(employee)}>
                    <Typography
                      variant="body2"
                      sx={{
                        fontWeight: employee.nextReviewDate &&
                          new Date(employee.nextReviewDate) < new Date() &&
                          employee.status !== 'completed' &&
                          employee.status !== 'acknowledged'
                          ? 'bold'
                          : 'normal'
                      }}
                    >
                      {employee.nextReviewDate || 'Not scheduled'}
                    </Typography>
                  </TableCell> */}
                  {/* <TableCell>
                    <Box sx={{ display: 'flex' }}>
                      <Tooltip title="View Details">
                        <IconButton
                          size="small"
                          onClick={(e) => {
                            e.stopPropagation();
                            onSelectEmployee(employee);
                          }}
                        >
                          <Info />
                        </IconButton>
                      </Tooltip>
                      <Tooltip title="Process Review">
                        <IconButton
                          size="small"
                          onClick={(e) => {
                            e.stopPropagation();
                            onSelectEmployee(employee);
                          }}
                          disabled={employee.hrStatus !== 'pending_hr_review'}
                        >
                          <Edit />
                        </IconButton>
                      </Tooltip>
                    </Box>
                  </TableCell> */}
                </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell colSpan={9} align="center">
                  <Typography variant="body1" color="text.secondary" sx={{ py: 2 }}>
                    No employees match your filters
                  </Typography>
                  <Button
                    variant="text"
                    startIcon={<Refresh />}
                    onClick={handleResetFilters}
                    sx={{ mt: 1 }}
                  >
                    Reset All Filters
                  </Button>
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>

      {/* Selection Summary */}
      {selectedEmployees.length > 0 && (
        <Box sx={{ mt: 2, p: 2, bgcolor: '#E8F5E9', borderRadius: 1, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <Typography variant="body1" fontWeight="medium">
            {selectedEmployees.length} employee(s) selected for appraisal report sharing
          </Typography>
          <Button
            variant="outlined"
            startIcon={<Email />}
            onClick={handleShareAppraisalReports}
            disabled={isSharing}
            sx={{ textTransform: 'none' }}
          >
            Share Reports Now
          </Button>
        </Box>
      )}

      {/* Employee Details Modal */}
      <Modal open={openDialog} onClose={() => setOpenDialog(false)}>
        <Box sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: '80vw',
          maxHeight: '90vh',
          bgcolor: 'background.paper',
          borderRadius: 2,
          boxShadow: 24,
          overflow: 'hidden'
        }}>
          <Box sx={{ p: 3, borderBottom: '1px solid #e0e0e0' }}>
            <Typography variant="h6" fontWeight="bold">
              Employee Review Details - {selectedEmployee?.name || 'Unknown Employee'}
            </Typography>
            {currentPeriod && (
              <Typography variant="body2" color="text.secondary">
                Current Appraisal Period: {currentPeriod}
              </Typography>
            )}
          </Box>

          <Box sx={{ maxHeight: '70vh', overflow: 'auto', p: 3 }}>
            {selectedEmployee ? (
              <HREmployeeReviewDetails employee={selectedEmployee} />
            ) : (
              <Typography>No employee data available</Typography>
            )}
          </Box>

          <Box sx={{ p: 2, borderTop: '1px solid #e0e0e0', textAlign: 'right' }}>
            <Button variant="outlined" color="primary" onClick={() => setOpenDialog(false)}>
              CLOSE
            </Button>
          </Box>
        </Box>
      </Modal>

      {/* Snackbar for notifications */}
      <Snackbar
        open={snackbar.open}
        autoHideDuration={6000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <Alert onClose={handleCloseSnackbar} severity={snackbar.severity} sx={{ width: '100%' }}>
          {snackbar.message}
        </Alert>
      </Snackbar>

    </Paper>
  );
};

export default HREmployeeReviewList;